module.exports = __webpack_public_path__ + "static/img-paralax-1-d237edcb0be15b04dda992e25e475dc4.png";